var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.showBanner)?_c('div',{staticClass:"banner"},[_c('span',[_vm._v("\n      You are in cache bypass mode\n      "),_c('button',{staticClass:"exit",on:{"click":_vm.exitCacheBypass}},[_vm._v("\n        press here to exit\n      ")]),_vm._v("\n      .\n    ")])]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }